import React from "react";

const SocialShare = [
  {
    iconName: "github",
    link: "https://github.com/ScottAnk",
  },
  {
    iconName: "iconmonstr-linkedin-3",
    link: "https://www.linkedin.com/in/scott-ankiewicz/",
  },
  {
    iconName: "leetcode",
    link: "https://leetcode.com/scottank/",
  },
  {
    iconName: "stackOverflow",
    link: "https://stackoverflow.com/users/21087899/scottank",
  },
  // {
  //   iconName: "medium",
  //   link: "https://medium.com/@scottfa.a",
  // },
];
const Social = () => {
  return (
    <>
      <ul className="social">
        {SocialShare.map((val, i) => (
          <li key={i}>
            <a href={`${val.link}`} target="_blank" rel="noreferrer">
              <img
                className="svg"
                src={`/assets/img/svg/social/${val.iconName}.svg`}
                alt="social"
              ></img>
            </a>
          </li>
        ))}
      </ul>
      {/* END SOCIAL */}
    </>
  );
};

export default Social;
